const getRoot = state => state.__KNOWLEDGEBASE.search

export const getSearchResults = state => getRoot(state).searchResults.articles
export const getRenderSearchTable = state => getRoot(state).renderSearchTable
export const getSearchInput = state => getRoot(state).searchInput
export const getIsSearchPending = state => getRoot(state).isSearchPending